module.exports = __webpack_public_path__ + "img/topArrows.02647fd1.png";